import { render, staticRenderFns } from "./ui-checkbox.vue?vue&type=template&id=5c4ce800&scoped=true&"
import script from "./ui-checkbox.vue?vue&type=script&lang=ts&"
export * from "./ui-checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./ui-checkbox.vue?vue&type=style&index=0&id=5c4ce800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ce800",
  null
  
)

export default component.exports